import { httpV2 } from "@/api/index";

/**
 * @summary Obtém todos os sinais e seus limites customizados da turbina requisitada.
 * @param monitoringElementId Id do elemento de monitoramento do ativo.
 * @returns Retorna um JSON com todos os sinais e seus limites costumizados da turbina.
 */
const GetTrendLimitsData = function(monitoringElementId)
{
	return httpV2.get(`/HydroSignalLimits/asset/${monitoringElementId}/TrendLimits`);
};

/**
 * @summary Requisição para a criação de um novo alerta de limites de sinais.
 * @param parameters - Objeto contendo dados do sinal customizado.
 */
const CreateTrendLimitsData = function(parameters)
{
	return httpV2.post("/HydroSignalLimits/TrendLimits", parameters);
};

/**
 * @summary Solicita o status do protocolo de um conjunto de unidades geradoras.
 * @param {object} parameters - Ids das turbinas.
 */

const UpdateTrendsLimitsData = function(parameters)
{
	return httpV2.patch(`/HydroSignalLimits/TrendLimits/${parameters.signalMonitoringElementId}`,
		parameters,
		{ headers: { "Content-Type": "application/json" }, });
};

/**
 * @summary Solicita o status do protocolo de um conjunto de unidades geradoras.
 * @param {object} parameters - Ids das turbinas.
 */
const DeleteTrendLimitsData = function(parameters)
{
	return httpV2.delete(`/HydroSignalLimits/asset/${parameters.assetMonitoringElementId}/TrendLimits/
	${parameters.trendSignalSettingId}/Signal/
	${parameters.trendSignalMonitoringElementId}`);
};

export default {
	GetTrendLimitsData,
	CreateTrendLimitsData,
	UpdateTrendsLimitsData,
	DeleteTrendLimitsData,
};